/** Dwarven roster — UNIT_ART indices 7..11, redrawn at double resolution. */
export const ART_UNITS_DWARF: string[][][] = [
  /* 7 Shieldbearer — squat, brass-banded pot helm, gold beard down to the belt,
     a full tower shield in iron rim + kingdom field, war-hammer on the shoulder */
  [
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '       dddd mmm ',
      '      dmmmmd mm ',
      ' mmmmmdyyyyd w  ',
      ' mPPPmdkddkd w  ',
      ' mPPPmyyyyyydw  ',
      ' mPyPmyyyyyydw  ',
      ' mPyPmwyyyywdw  ',
      ' mPPPmPyyyyPdw  ',
      ' mPPPmPPPPPPdw  ',
      ' mPPPm pPPp d   ',
      ' mmmmm dd dd    ',
      '       ## ##    ',
    ],
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '                ',
      '       dddd mmm ',
      '      dmmmmd mm ',
      ' mmmmmdyyyyd w  ',
      ' mPPPmdkddkd w  ',
      ' mPPPmyyyyyydw  ',
      ' mPyPmyyyyyydw  ',
      ' mPyPmwyyyywdw  ',
      ' mPPPmPyyyyPdw  ',
      ' mPPPmPPPPPPd   ',
      ' mmmmmdd  ppd   ',
      '      ##   ##   ',
    ],
  ],
  /* 8 Crossbowman — braced side-on. The arbalest's steel prod stands as a vertical
     bar off the leading edge, tiller laid horizontally across the chest with the
     beard spilling over it, support hand slung under the stock, quarrel quiver on
     the trailing hip, front boot driven forward into the stirrup. */
  [
    [
      '                ',
      '                ',
      '                ',
      '       dddd     ',
      '      dmmmmd    ',
      '     ddyyyydd   ',
      '      dkdddd    ',
      '     yyyyyyyy   ',
      ' md  yyyyyy mm  ',
      ' dd   yyyy  bb  ',
      ' dmwwwwwwwwPqq  ',
      ' dd P    PPPqq  ',
      ' md     PPPPq   ',
      '       PPPPP    ',
      '    ppPP  PPp   ',
      '  ####     ###  ',
    ],
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '       dddd     ',
      '      dmmmmd    ',
      '     ddyyyydd   ',
      '      dkdddd    ',
      '     yyyyyyyy   ',
      ' md  yyyyyy mm  ',
      ' dd   yyyy  bb  ',
      ' dmwwwwwwwwPqq  ',
      ' md P    PPPqq  ',
      '      PPPPPP    ',
      '    pPPP  PPp   ',
      '   ###     ###  ',
    ],
  ],
  /* 9 Runesmith — square-on and top-heavy: a great rune-lit maul held high over the
     right shoulder as a block of mass in the top corner, the off arm swung clear of
     the ribs around a burning sigil-stone, and a long leather apron flaring from the
     chest to a pair of wide flat boots — no mail, no leg gap until the hem. */
  [
    [
      '          ddddd ',
      '          dmmmd ',
      '          dcccd ',
      '     dddd ddddd ',
      '    dmmmmd  ww  ',
      '   ddyyyydd ww  ',
      '    dkddkd  ww  ',
      '   yyyyyyyy ww  ',
      ' PPwyyyyyywPPw  ',
      ' PPqqqqqqqPPP   ',
      ' PPqqcccqqqP    ',
      'PP PqqqqqqqqP   ',
      'cv PqqqqqqqqqP  ',
      ' v PqqqqqqqqqP  ',
      '   pqqp  pqqp   ',
      '  #####  #####  ',
    ],
    [
      '                ',
      '          ddddd ',
      '          dmmmd ',
      '          dcccd ',
      '     dddd ddddd ',
      '    dmmmmd  ww  ',
      '   ddyyyydd ww  ',
      '    dkddkd  ww  ',
      '   yyyyyyyy ww  ',
      ' PPwyyyyyywPPw  ',
      ' PPqqcccqqqPP   ',
      'PP PqqqqqqqqP   ',
      ' c PqqqqqqqqqP  ',
      'vc PqqqqqqqqqP  ',
      '   pqqp   pqqp  ',
      '  #####   ##### ',
    ],
  ],
  /* 10 Sapper — miner's leather cap with a lit lamp, short beard, pickaxe over the
     shoulder in frame 0 and swung down in frame 1, blackpowder keg on the hip */
  [
    [
      '                ',
      '                ',
      '                ',
      '          mmmmm ',
      '          d w d ',
      '     qqqqqq w   ',
      '    yqqqqqq w   ',
      '     skssks w   ',
      '    yyyyyyyyw   ',
      '    wyyyyyywd   ',
      '  r qPPPPPPqw   ',
      ' qbqqPPPPPPqw   ',
      ' bbbqPPPPPPqw   ',
      ' qbqPPPPPPPPd   ',
      '    pdd  ddp    ',
      '     ##  ##     ',
    ],
    [
      '                ',
      '                ',
      '                ',
      '                ',
      '                ',
      '     qqqqqq     ',
      '    yqqqqqq     ',
      '     skssks     ',
      '    yyyyyyyy    ',
      '    wyyyyyywd   ',
      '  r qPPPPPPq w  ',
      ' qbqqPPPPPPq w  ',
      ' bbbqPPPPPPqmmm ',
      ' qbqPPPPPPPPd d ',
      '    dd   pp     ',
      '   ##     ##    ',
    ],
  ],
  /* 11 Battle Golem (20x20) — walking granite, brass joint bands, a rune array
     burning in the chest cavity, fists the size of its own head */
  [
    [
      '                    ',
      '                    ',
      '                    ',
      '        nnnn        ',
      '       nNccNn       ',
      '       nNNNNn       ',
      '      nnnnnnnn      ',
      '   nnnNNNNNNNNnnn   ',
      '  nnnNNPPPPPPNNnnn  ',
      '  nNn nPPPPPPn nNn  ',
      '  nyn nPccccPn nyn  ',
      '  nNn nPcyycPn nNn  ',
      '  nNn nPccccPn nNn  ',
      '  nNn nPPPPPPn nNn  ',
      ' nnNn nnnnnnnn nNnn ',
      ' nnnn nnnnnnnn nnnn ',
      '      nNn  nNn      ',
      '      nyn  nyn      ',
      '     nnnn  nnnn     ',
      '     ####  ####     ',
    ],
    [
      '                    ',
      '                    ',
      '                    ',
      '                    ',
      '        nnnn        ',
      '       nNccNn       ',
      '       nNNNNn       ',
      '      nnnnnnnn      ',
      '   nnnNNNNNNNNnnn   ',
      '  nnnNNPPPPPPNNnnn  ',
      '  nNn nPccccPn nNn  ',
      '  nyn nPcyycPn nyn  ',
      ' nnnn nPccccPn nNn  ',
      ' nnnn nPPPPPPn nNn  ',
      '      nnnnnnnn nNn  ',
      '      nnnnnnnn nnnn ',
      '     nNn   nNn nnnn ',
      '    nyn     nyn     ',
      '   nnnn     nnnn    ',
      '   ####     ####    ',
    ],
  ],
];
